export const TRAMITE_TAREAS_ROUTES = {
  BASES: '/tareas-base',
} as const;
